import { Injectable } from '@angular/core';

declare var gtag;

@Injectable({
  providedIn: 'root',
})
export class DiaryAnalyticsService {
  constructor() {}

  analyticDiaryVisited() {
    gtag('event', 'diary_visited', {
      event_category: 'Diary Events',
    });
  }

  analyticDiaryGetDietStarted() {
    gtag('event', 'diary_get_diet_started', {
      event_category: 'Diary Events',
    });
  }

  analyticDiaryGetDietCompleted(
    type: string,
    isVegetarian: boolean,
    difficulty: string,
    activity: string,
    isHated: boolean,
    isDiseased: boolean,
    dayDifference: number
  ) {
    let json: JSON;
    let obj: any = {
      type: type,
      is_vegetarian: isVegetarian,
      difficulty: difficulty,
      activity: activity,
      is_hated: isHated,
      isDiseased: isDiseased,
      day_difference: dayDifference,
    };
    json = <JSON>obj;
    gtag('event', 'diary_get_diet_completed', {
      event_category: 'Diary Events',
      event_label: JSON.stringify(json),
    });
  }

  analyticDiaryPackageVisited() {
    gtag('event', 'diary_package_visited', {
      event_category: 'Diary Events',
    });
  }

  analyticDiaryPackageStatusChanged(status: string, day: string) {
    let json: JSON;
    let obj: any = {
      status: status,
      day: day,
    };
    json = <JSON>obj;
    gtag('event', 'diary_package_status_changed', {
      event_category: 'Diary Events',
      event_label: JSON.stringify(json),
    });
  }

  analyticDiaryPackageSearchPackageVisited() {
    gtag('event', 'diary_package_search_package_visited', {
      event_category: 'Diary Events',
    });
  }

  analyticDiaryPackageChanged(meal: string) {
    let json: JSON;
    let obj: any = {
      meal: meal,
    };
    json = <JSON>obj;
    gtag('event', 'diary_package_changed', {
      event_category: 'Diary Events',
      event_label: JSON.stringify(json),
    });
  }

  analyticDiaryPackageFoodEdited() {
    gtag('event', 'diary_package_food_edited', {
      event_category: 'Diary Events',
    });
  }

  analyticDiaryPackageFoodDeleted() {
    gtag('event', 'diary_package_food_deleted', {
      event_category: 'Diary Events',
    });
  }

  analyticDiaryPackageSearchFoodVisited() {
    gtag('event', 'diary_package_search_food_visited', {
      event_category: 'Diary Events',
    });
  }

  analyticDiaryPackageFoodAdded() {
    gtag('event', 'diary_package_food_added', {
      event_category: 'Diary Events',
    });
  }

  analyticDiaryCheatDaySelected(day: number) {
    let json: JSON;
    let obj: any = {
      day: day,
    };
    json = <JSON>obj;
    gtag('event', 'diary_cheat_day_selected', {
      event_category: 'Diary Events',
      event_label: JSON.stringify(json),
    });
  }

  analyticDiaryCheatDayCanceled() {
    gtag('event', 'diary_cheat_day_canceled', {
      event_category: 'Diary Events',
    });
  }

  analyticDiaryWaterChanged() {
    gtag('event', 'diary_water_changed', {
      event_category: 'Diary Events',
    });
  }

  analyticDiaryWeightChanged() {
    gtag('event', 'diary_weight_changed', {
      event_category: 'Diary Events',
    });
  }

  analyticDiaryDietCanceled(day: number) {
    let json: JSON;
    let obj: any = {
      day: day,
    };
    json = <JSON>obj;
    gtag('event', 'diary_diet_canceled', {
      event_category: 'Diary Events',
      event_label: JSON.stringify(json),
    });
  }

  analyticDiaryStartDayChanged(dayDifference: number) {
    let json: JSON;
    let obj: any = {
      day_difference: dayDifference,
    };
    json = <JSON>obj;
    gtag('event', 'diary_diet_start_day_changed', {
      event_category: 'Diary Events',
      event_label: JSON.stringify(json),
    });
  }

  analyticDiaryDateNavigated() {
    gtag('event', 'diary_date_navigated', {
      event_category: 'Diary Events',
    });
  }

  analyticDiaryDateChanged() {
    gtag('event', 'diary_date_changed', {
      event_category: 'Diary Events',
    });
  }
  analyticDiaryActivityVisited() {
    gtag('event', 'diary_activity_visited', {
      event_category: 'Diary Events',
    });
  }
  analyticDiaryAddActivityVisited() {
    gtag('event', 'diary_add_activity_visited', {
      event_category: 'Diary Events',
    });
  }

  analyticDiarySearchActivityVisited() {
    gtag('event', 'diary_search_activity_visited', {
      event_category: 'Diary Events',
    });
  }
  analyticDiaryAddSearchActivity() {
    gtag('event', 'diary_search_activity_added', {
      event_category: 'Diary Events',
    });
  }
  analyticDiaryAddRecentSearchActivity() {
    gtag('event', 'diary_recent_activity_added', {
      event_category: 'Diary Events',
    });
  }
  analyticDiarySimpleActivityAdd() {
    gtag('event', 'diary_simple_activity_calorie_added', {
      event_category: 'Diary Events',
    });
  }
  analyticDiaryActivityEdit() {
    gtag('event', 'diary_activity_log_edited', {
      event_category: 'Diary Events',
    });
  }
  analyticDiaryActivityDelete() {
    gtag('event', 'diary_activity_log_deleted', {
      event_category: 'Diary Events',
    });
  }
}
